import { ObservableModelNode } from "./observable";
import {
  cloneValue,
  expectObject,
  readBoolean,
  readNullableString,
  readOptionalNumber,
  readString,
  splitKnown,
} from "./utils";
import type { JsonObject } from "./utils";
import type { RawSpecSide } from "../types";

export class GeneratorSideModel extends ObservableModelNode {
  name!: string;
  zIndex!: number | null;
  zIndexHighlight!: number | null;
  imageUrl!: string | null;
  highlightUrl!: string | null;
  alwaysRedraw!: boolean;
  extra!: JsonObject;
  private hasZIndex = false;
  private hasZIndexHighlight = false;
  private hasImageUrl = false;
  private hasHighlightUrl = false;
  private hasAlwaysRedraw = false;

  constructor() {
    super();
    this.defineObservableValue("name", "");
    this.defineObservableValue("zIndex", null);
    this.defineObservableValue("zIndexHighlight", null);
    this.defineObservableValue("imageUrl", null);
    this.defineObservableValue("highlightUrl", null);
    this.defineObservableValue("alwaysRedraw", false);
    this.defineObservableValue("extra", {});
  }

  restore(data: unknown) {
    const source = expectObject(data, "generator side");
    this.hasZIndex = "zIndex" in source;
    this.hasZIndexHighlight = "zIndexHighlight" in source;
    this.hasImageUrl = "imageUrl" in source;
    this.hasHighlightUrl = "highlightUrl" in source;
    this.hasAlwaysRedraw = "alwaysRedraw" in source;

    this.extra = splitKnown(source, [
      "name",
      "zIndex",
      "zIndexHighlight",
      "imageUrl",
      "highlightUrl",
      "alwaysRedraw",
    ]);
    this.name = readString(source, "name");
    this.zIndex = readOptionalNumber(source, "zIndex");
    this.zIndexHighlight = readOptionalNumber(source, "zIndexHighlight");
    this.imageUrl = readNullableString(source, "imageUrl");
    this.highlightUrl = readNullableString(source, "highlightUrl");
    this.alwaysRedraw = readBoolean(source, "alwaysRedraw", false);

    return this;
  }

  save() {
    const saved: RawSpecSide & JsonObject = {
      ...cloneValue(this.extra),
      name: this.name,
    };

    if (this.hasZIndex || this.zIndex !== null) {
      saved.zIndex = this.zIndex;
    }
    if (this.hasZIndexHighlight || this.zIndexHighlight !== null) {
      saved.zIndexHighlight = this.zIndexHighlight;
    }
    if (this.hasImageUrl || this.imageUrl !== null) {
      saved.imageUrl = this.imageUrl;
    }
    if (this.hasHighlightUrl || this.highlightUrl !== null) {
      saved.highlightUrl = this.highlightUrl;
    }
    if (this.hasAlwaysRedraw || this.alwaysRedraw) {
      saved.alwaysRedraw = this.alwaysRedraw;
    }

    return saved;
  }
}
